import React, { useCallback, useEffect, useReducer, useRef, useState } from "react";

import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";
import { useCookies } from "react-cookie";
import Summary from "./partials/Summary";
import { getList, sendZNS, update } from "./controller";
import ConfirmPopup from './partials/ConfirmPopup';
import ZNSPopup from "./partials/ZNSPopup";
import ExportPopup from "./partials/ExportPopup";

export const Context = React.createContext(null);

const initialData = {
  filter: {
    method: 'BY_ID', // 'BY_CONDITION'
    from: new Date(),
    to: new Date(),
    phone: '',
    email: '',
    status: '',
    paymentMethod: '',
    id: '',
    page: 0
  },
  data: {
    list: [],
    total: 0,
    totalPage: 0
  },
  confirmPopup: {
    show: false,
    content: '',
    cartId: undefined,
    confirmed: false,
  },
  exportPopup: {
    show: false,
    image: '',
    image2: undefined,
    id: undefined,
    confirmed: false,
  },
  znsPopup: {
    show: false,
    content: '',
    cartId: undefined,
    confirmed: false,
  },
  filterPressCount: 0,
  exportPressCount: 0,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_FILTER':
      return {
        ...state,
        filter: {
          method: state.filter.method,
          ...action.payload,
          page: 0
        },
        filterPressCount: state.filterPressCount + 1
      }
    case 'CHANGE_FILTER_METHOD':
      return {
        ...state,
        filter: {
          from: new Date(),
          to: new Date(),
          phone: '',
          email: '',
          status: '',
          paymentMethod: '',
          id: '',
          page: 0,
          method: action.payload.method
        },
        data: {
          list: [],
          total: 0,
          totalPage: 0
        },
        filterPressCount: 0,
      }
    case 'UPDATE_DATA':
      return {
        ...state,
        data: {
          ...action.payload
        }
      }
    case 'OPEN_CONFIRM_POPUP':
      return {
        ...state,
        confirmPopup: {
          show: true,
          content: action.payload.content,
          confirmed: false,
          cartId: action.payload.cartId,
        }
      }
    case 'CLOSE_CONFIRM_POPUP':
      return {
        ...state,
        confirmPopup: {
          show: false,
          content: '',
          cartId: action.payload ? state.confirmPopup.cartId : undefined,
          confirmed: action.payload
        }
      }
    case 'OPEN_EXPORT_POPUP':
      return {
        ...state,
        exportPopup: {
          show: true,
          confirmed: false,
          id: action.payload.id,
        }
      }
    case 'CLOSE_EXPORT_POPUP':
      return {
        ...state,
        exportPopup: {
          show: false,
          image: action.payload.confirmed ? action.payload.image : '',
          image2: action.payload.confirmed ? action.payload.image2 : undefined,
          id: action.payload.confirmed ? state.exportPopup.id : undefined,
          confirmed: action.payload.confirmed
        }
      }
    case 'OPEN_ZNS_POPUP':
      return {
        ...state,
        znsPopup: {
          show: true,
          content: action.payload.content,
          confirmed: false,
          cartId: action.payload.cartId,
        }
      }
    case 'CLOSE_ZNS_POPUP':
      return {
        ...state,
        znsPopup: {
          show: false,
          content: '',
          cartId: action.payload ? state.znsPopup.cartId : undefined,
          confirmed: action.payload
        }
      }
    case 'UPDATE_PAGE':
      return {
        ...state,
        filter: {
          ...state.filter,
          page: action.payload
        },
        filterPressCount: state.filterPressCount + 1
      }
    default:
      return {
        ...state
      }
  }
}

export default () => {

  var [state, dispatch] = useReducer(reducer, initialData);

  const [cookies] = useCookies(['wvivu'])

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  const filterPressCount = useRef(state.filterPressCount)

  const getAllFunc = useCallback(async () => {
    setLoading(true)
    const filterObj = state.filter.method === 'BY_CONDITION' ? {
      from: state.filter.from,
      to: state.filter.to,
      phone: state.filter.phone,
      email: state.filter.email,
      status: state.filter.status,
      paymentMethod: state.filter.paymentMethod,
    } : {
      id: state.filter.id,
    }
    const response = await getList(cookies.wvivu, filterObj, state.filter.page)

    if (response) {
      setError(false)
      dispatch({
        type: 'UPDATE_DATA',
        payload: response
      })
    } else {
      setError(true)
    }
    setLoading(false)
  }, [
    cookies.wvivu,
    state.filter.from,
    state.filter.to,
    state.filter.page,
    state.filter.phone,
    state.filter.email,
    state.filter.status,
    state.filter.paymentMethod,
    state.filter.method,
    state.filter.id,
  ])

  const updateCartFunc = useCallback(async (cartId) => {
    const response = await update(cookies.wvivu, cartId, 'CONFIRM_PAYMENT')

    if (response) {
      setError(false)
      getAllFunc()
    } else {
      setError(true)
    }
  }, [cookies.wvivu, getAllFunc])

  const sendZNSFunc = useCallback(async (cartId) => {
    const response = await sendZNS(cookies.wvivu, cartId)

    if (response) {
      setError(false)
      getAllFunc()
    } else {
      setError(true)
    }
  }, [cookies.wvivu, getAllFunc])

  const confirmFunc = useCallback(async (id, image, image2) => {
    const response = await update(cookies.wvivu, id, 'EXPORT', {
      image: image,
      image2: image2,
      id: id
    })

    if (response) {
      setError(false)
      getAllFunc()
    } else {
      setError(true)
    }
  }, [cookies.wvivu, getAllFunc])

  useEffect(() => {
    if (state.filterPressCount > 0 && filterPressCount.current < state.filterPressCount) {
      getAllFunc()
    }
    filterPressCount.current = state.filterPressCount
  }, [getAllFunc, state.filterPressCount])

  useEffect(() => {
    document.title = "Đơn mua vé"
  }, []);

  useEffect(() => {
    if (state.confirmPopup.confirmed && state.confirmPopup.cartId) {
      updateCartFunc(state.confirmPopup.cartId)
    }
  }, [updateCartFunc, state.confirmPopup.confirmed, state.confirmPopup.cartId])

  useEffect(() => {
    if (state.znsPopup.confirmed && state.znsPopup.cartId) {
      sendZNSFunc(state.znsPopup.cartId)
    }
  }, [sendZNSFunc, state.znsPopup.confirmed, state.znsPopup.cartId])

  useEffect(() => {
    if (state.exportPopup.confirmed && state.exportPopup.id && state.exportPopup.image) {
      confirmFunc(state.exportPopup.id, state.exportPopup.image, state.exportPopup.image2)
    }
  }, [confirmFunc, state.exportPopup.confirmed, state.exportPopup.id])

  return (
    <Context.Provider value={{
      state,
      dispatch
    }}>

      <FilterForm />

      <br />

      <Summary />

      <br />

      {loading ? 'Loading.....' : error ? 'Lỗi!?' : <Table />}

      <ConfirmPopup />
      <ExportPopup />
      <ZNSPopup />
    </Context.Provider>
  );
};
